import { getToken } from './auth';
import { GHIN_STAGING_URL } from './config';

export interface GolferSearchResult {
  ghin: string;
  first_name: string;
  last_name: string;
  gender: string;
  status: string;
  association_id: number;
  association_name: string;
  club_id: number;
  club_name: string;
  state: string;
  handicap_index: string | null;
  hi_display: string | null;
  low_hi: string | null;
  is_home_club: boolean;
  rev_date: string | null;
}

export interface GolfersSearchResponse {
  success: boolean;
  status: number;
  data?: {
    golfers: GolferSearchResult[];
    total_records?: number;
  };
  error?: string;
}

export async function golfersSearch(ghin: string, status?: 'Active' | 'Inactive'): Promise<GolfersSearchResponse> {
  const token = getToken();
  if (!token) {
    return { success: false, status: 401, error: 'Not authenticated' };
  }

  const params: Record<string, string> = { per_page: '100', page: '1', golfer_id: ghin, sorting_criteria: 'status', order: 'ASC' };
  if (status) params['status'] = status;
  const searchParams = new URLSearchParams(params);

  const url = `${GHIN_STAGING_URL}/golfers/search.json?${searchParams}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  const data = await response.json();

  if (response.ok) {
    return { success: true, status: response.status, data };
  }

  return {
    success: false,
    status: response.status,
    error: data.message || 'Failed to search golfers',
  };
}
